module.exports = __webpack_public_path__ + "static/reason-4-4193b82f9afa7ab3f3e0cf33b4bc997a.svg";